import React, {useRef, useState, useEffect} from "react";
import styles from "./ExternalAppInfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'

export default function InfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.title}
        </td>
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.gongsi_name}*/}
        {/*</td>*/}
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.app_type}*/}
        {/*</td>*/}
        <td
            className={styles.td1}
        >{props.item.status==1?"开启":"关闭"}
        </td>
        <td
            className={styles.td1}
        >
            {props.item.dianji_num}
            {/*<Switch*/}
            {/*    checked={props.item.status == 1}*/}
            {/*    onChange={(checked) => {*/}
            {/*        console.log(checked);*/}
            {/*        props.changeStatus(props.item, checked);*/}
            {/*    }}*/}
            {/*    checkedChildren="开"*/}
            {/*    unCheckedChildren="关"*/}
            {/*    // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}*/}
            {/*    style={{marginLeft: 10, marginRight: 10}}*/}
            {/*/>*/}

        </td>
        <td
            className={styles.td1}
        >{props.item.ctime}
        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

